"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'state_code',
        method: 'foraFinancialWarehouseLlcTruistBank1.singleState',
        type: 'string',
        exclusion: {
            largestNumberOfGroups: 3,
        },
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map